import React from 'react'

import Modal from 'react-awesome-modal'
import { Button } from 'loyal-react'
import 'loyal-design-system/assets/css/template/modal.css'

import Automotivo from '@loyal_images/banners/categoria-interesse/automotivo.jpg'
import Bebes from '@loyal_images/banners/categoria-interesse/bebes.jpg'
import BemEstar from '@loyal_images/banners/categoria-interesse/bem-estar.jpg'
import CasaCozinha from '@loyal_images/banners/categoria-interesse/casa.jpg'
import Eletronicos from '@loyal_images/banners/categoria-interesse/eletronicos.jpg'
import Gastronomia from '@loyal_images/banners/categoria-interesse/gastronomia.jpg'
import IndustriaComercio from '@loyal_images/banners/categoria-interesse/industria.jpg'
import LazerCultura from '@loyal_images/banners/categoria-interesse/lazer.jpg'
import Moda from '@loyal_images/banners/categoria-interesse/moda.jpg'
import Tabacaria from '@loyal_images/banners/categoria-interesse/tabacaria.jpg'
import Veiculos from '@loyal_images/banners/categoria-interesse/veiculos.jpg'
import Viagens from '@loyal_images/banners/categoria-interesse/viagem.jpg'

const ModalCategories = () => (
  <div className='modalCategories pos-relative container'>
    <Modal visible={false} height='auto' effect='fadeInUp'>
      <div className='col-12 border-color-ui-3 bg-white border radius'>
        <div className='categories-step row px-3 py-2 border-bottom border-color-ui-3 '>
          <div className='col py-1 mr-auto'>
            <h3 className='txt-initial color-brand-1 mr-auto'>
              Selecione ao menos 3 categorias que tenha interesse
            </h3>
          </div>
          <div className={`col-auto`}>
            <Button className='btn btn-sm btn-featured' text='Continuar' />
          </div>
        </div>
        <div className='categories-list row px-2 pt-3'>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item1' className='radius'>
                  <input
                    id='item1'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Automotivo</h2>
                  <img
                    src={Automotivo}
                    alt='Automotivo'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item2' className='radius'>
                  <input
                    id='item2'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Bebês</h2>
                  <img
                    src={Bebes}
                    alt='Bebês'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item3' className='radius'>
                  <input
                    id='item3'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Bem estar</h2>
                  <img
                    src={BemEstar}
                    alt='Bem estar'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item4' className='radius'>
                  <input
                    id='item4'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Casa e cozinha</h2>
                  <img
                    src={CasaCozinha}
                    alt='Casa e cozinha'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className='categories-list row px-2 pt-3'>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item5' className='radius'>
                  <input
                    id='item5'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Eletrônicos</h2>
                  <img
                    src={Eletronicos}
                    alt='Eletrônicos'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item6' className='radius'>
                  <input
                    id='item6'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Gastronimia</h2>
                  <img
                    src={Gastronomia}
                    alt='Gastronimia'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item7' className='radius'>
                  <input
                    id='item7'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Indústria e Comércio</h2>
                  <img
                    src={IndustriaComercio}
                    alt='Indústria e Comércio'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item8' className='radius'>
                  <input
                    id='item8'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Lazer e Cultura</h2>
                  <img
                    src={LazerCultura}
                    alt='Lazer e Cultura'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className='categories-list row px-2 py-3'>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item9' className='radius'>
                  <input
                    id='item9'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Moda</h2>
                  <img
                    src={Moda}
                    alt='Moda'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item10' className='radius'>
                  <input
                    id='item10'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Tabacaria</h2>
                  <img
                    src={Tabacaria}
                    alt='Tabacaria'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item11' className='radius'>
                  <input
                    id='item11'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Veículos</h2>
                  <img
                    src={Veiculos}
                    alt='Veículos'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='categories-item col-2 col-md-3 px-2'>
            <div className='row'>
              <div className='col-12 px-half'>
                <label htmlFor='item12' className='radius'>
                  <input
                    id='item12'
                    type='checkbox'
                    name='categories-choose'
                    className='categories-choose d-none'
                  />
                  <h2 className='txt-body'>Viagens</h2>
                  <img
                    src={Viagens}
                    alt='Viagens'
                    className='img-w-auto'
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
)

export default ModalCategories



// WEBPACK FOOTER //
// ./src/HomePage/ModalCategories/ModalCategories.js